import React from "react";
import Header from "../../Home/Header";
import MMakingSHero from "./MMakingSHero";
import Footer from "../../Home/Footer";
import PartnerWithUs from "./PartnerWithUs";
import WhatIsMMS from "./WhatIsMMS";
import AdvancedATrading from "./AdvancedATrading";
import ExperiencedTeam from "./ExperiencedTeam";
import PriceStability from "./PriceStability";
import WhyChoose from "../../Wallet/NFT Wallet/WhyChoose";

function MarketMakingServices() {
  return (
    <div>
      <Header />
      <MMakingSHero />
      <PartnerWithUs />
      <WhatIsMMS />
      <AdvancedATrading />
      <PriceStability />
      <WhyChoose />
      <Footer />
    </div>
  );
}

export default MarketMakingServices;
